import {
  ExclamationCircleOutlined,
  SafetyCertificateOutlined
} from "@ant-design/icons"
import { Tag, Tooltip } from "antd"
import { useTranslation } from "react-i18next"

export const SignedRecordTag = ({
  className = "!m-0 shrink-0",
  signedOutside = false
}: {
  className?: string
  /** Signed somewhere else and filed here: no audit trail stands behind it. */
  signedOutside?: boolean
}) => {
  const { t } = useTranslation()
  return (
    <Tooltip
      title={t(
        signedOutside
          ? "files.signedOutsideTooltip"
          : "files.signedRecordTooltip"
      )}
    >
      <Tag
        color={signedOutside ? "gold" : "green"}
        icon={
          signedOutside ? (
            <ExclamationCircleOutlined />
          ) : (
            <SafetyCertificateOutlined />
          )
        }
        className={className}
        data-testid={signedOutside ? "signed-outside-tag" : "signed-record-tag"}
      >
        {t(signedOutside ? "files.signedOutside" : "files.signedRecord")}
      </Tag>
    </Tooltip>
  )
}
